<template>
  <div class="py-2" :class="{ disabled }">
    <div
      class="flex items-center justify-between border-b border-solid border-b-strong pb-2"
      :class="{
        'cursor-pointer': !disabled,
      }"
      @click.prevent="toggleActive"
    >
      <div class="flex min-w-0 items-center">
        <SvgIcon class="mr-1" data-testid="expand-button" :path="isActive ? mdiChevronUp : mdiChevronDown" :size="18" />
        <div class="mr-2 min-w-0 overflow-hidden text-body-s-bold text-ellipsis whitespace-nowrap"><slot name="name" /></div>
      </div>
      <div class="flex min-w-0 shrink-0 text-body-s-bold"><slot name="actions" /></div>
    </div>
    <SlideTransition class="expandable-content" data-testid="slide-transition-section">
      <div class="pt-4" :class="{ hidden: !isActive }">
        <slot />
      </div>
    </SlideTransition>
  </div>
</template>

<script setup lang="ts">
import { mdiChevronDown, mdiChevronUp } from '@mdi/js'
import { SlideTransition } from '@ramp106/omrjs-core-ui'
import { ref, watch } from 'vue'

import SvgIcon from '@/components/SvgIcon.vue'

const props = defineProps<{ expanded?: boolean; disabled?: boolean }>()

const isActive = ref(props.expanded ?? false)

function toggleActive() {
  if (props.disabled) {
    return
  }
  isActive.value = !isActive.value
}

function open() {
  if (props.disabled) {
    return
  }
  isActive.value = true
}

function close() {
  if (props.disabled) {
    return
  }
  isActive.value = false
}

defineExpose({ open, close })

watch(
  () => props.disabled,
  () => {
    isActive.value = false
  },
)
</script>
<style scoped>
.disabled {
  opacity: 0.7;
}
</style>
